<template>
  <b-container>
    <h1>Report</h1>

    <b-button
        variant="outline-primary"
        v-on:click="dumpData()"
      >
        <b-icon-download></b-icon-download>Download
      </b-button>

    <vue-bootstrap4-table :rows="rows" :columns="columns" :config="config">
    <template slot="sort-asc-icon">
      <b-icon-arrow-up-short class="fas fa-sort-up"></b-icon-arrow-up-short>
    </template>
    <template slot="sort-desc-icon">
        <b-icon-arrow-down-short class="fas fa-sort-down"></b-icon-arrow-down-short>
    </template>
    <template slot="no-sort-icon">
        <b-icon-arrow-up-down class="fas fa-sort"></b-icon-arrow-up-down>
    </template>
    </vue-bootstrap4-table>
  </b-container>
</template>
<script>
import { mixins } from "../mixins";
import VueBootstrap4Table from "vue-bootstrap4-table";
import exportFromJSON from 'export-from-json';

export default {
  name: "report",
  mixins: [mixins],
  components: {
    VueBootstrap4Table
  },
  data() {
    return {
      rows: [],
      columns: [
        {
          label: "Name",
          name: "name",
          sort: true
        },
        {
          label: "Western ID",
          name: "westernId",
          sort: true
        },
        {
          label: "School District",
          name: "schoolDistrict",
          visibility: false
        },
        {
          label: "Course Title",
          name: "title",
          sort: true
        },
        {
          label: "Term",
          name: "term",
          visibility: false
        },
        {
          label: "CRN",
          name: "crn",
          visibility: false
        },
        {
          label: "Subject",
          name: "subject",
          visibility: false
        },
        {
          label: "EMail",
          name: "email"
        },
        {
          label: "Phone Number",
          name: "phone"
        },
        {
          label: "Application ID",
          name: "applicationId",
          visibility: false
        },
        {
          label: "Account Activated",
          name: "accountActivated"
        },
        {
          label: "Credit Hours",
          name: "creditHours"
        },
        {
          label: "Owed",
          name: "amountOwed",
          visibility: false
        }
      ],
      config: {
        card_title: "Teacher Institute Students",
        multi_column_sort: false,
        pagination: false,
        card_mode: true,
        show_refresh_button: false,
        show_reset_button: false
      }
    };
  },
  async created() {
    await this.pullApplicants()
  },
  methods: {
    pullApplicants() {
      this.api("/secure/dataDump")
        .then(response => {
          this.rows = response.data;
        })
        .catch(error => {
          this.errorToast(error.response.data.message || error.message || "");
        });
    },
    dumpData() {
       let data = this.rows;
       exportFromJSON({data:data, fileName: 'TIDump', exportType: 'csv'})
    }
  }
};
</script>
